module.exports = __webpack_public_path__ + "static/img/blacksea_logo_small.ec5bc1e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/blacksea_logo_small.svg
// module id = hbaS
// module chunks = 1